function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFinCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    width: 40,
    height: 40,
    rx: 11.1111,
    fill: "#E4F2E6",
    style: {
      fill: "#E4F2E6",
      fill: "color(display-p3 0.8941 0.9490 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 26.6665C14.2305 27.8938 13.2356 28.8887 12.0083 28.8887C10.781 28.8887 9.78613 27.8938 9.78613 26.6665V21.1108C9.78613 19.8836 10.781 18.8887 12.0083 18.8887C13.2356 18.8887 14.2305 19.8836 14.2305 21.1108V26.6665ZM29.7866 11.1113C31.0139 11.1113 32.0088 12.1063 32.0088 13.3336V26.6664C32.0088 27.8937 31.0134 28.8887 29.7861 28.8887C28.5588 28.8887 27.5635 27.8937 27.5635 26.6664V17.7778C27.5635 16.5506 26.5686 15.5557 25.3413 15.5557C24.114 15.5557 23.1191 16.5506 23.1191 17.7778V26.6665C23.1191 27.8938 22.1242 28.8887 20.897 28.8887C19.6697 28.8887 18.6748 27.8938 18.6748 26.6665V17.7779C18.6748 16.5506 17.6799 15.5557 16.4526 15.5557H12.0083C10.781 15.5557 9.78613 14.5608 9.78613 13.3335C9.78613 12.1062 10.781 11.1113 12.0083 11.1113H29.7866Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFinCardIcon);
export default __webpack_public_path__ + "static/media/myFinCardIcon.c211bfa1913e54431c5cbcab7b3f670d.svg";
export { ForwardRef as ReactComponent };